import { getLocaleFromRequest } from '@eventbrite/webapp-locales';
import { getLocaleTranslations } from './dictionaries';
import { IncomingMessage } from 'http';

export const getLocaleMessages = async (request: IncomingMessage) => {
  const tldLocale = await getLocaleFromRequest(request);
  return getLocaleTranslations(tldLocale);
};

export const getLocaleCode = async (request: IncomingMessage) => {
  const tldLocale = getLocaleFromRequest(request);
  return tldLocale.replace('_', '-');
};
